import { SearchArticleType } from '@services/types'

export const ARTICLE_PARAM_KEY_KEYWORD: SearchArticleType = 'keyword'

export const ARTICLE_PARAM_KEY_REQUEST: SearchArticleType =
	'incident_features_id'

export const ARTICLES_BASE_URL: string = '/articles/'
